export const downloadFileFromUrl = (filename, url) => {
  fetch(url).then(response =>
    response.blob().then(b => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.setAttribute('download', filename);
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(a.href);
      }, 100);
    }),
  );
};
